// wss message structure document
// 		wss return a payLoad struc with 2 atributes:
// 		payLoad.entity
import { writable } from 'svelte/store'

import type { WssPayLoad } from '$lib/stores/wss/types'

export const wssCheckThis_store = writable({} as WssPayLoad)





